export const actions = {
  FORMAS_PAGO_LOAD_REQUESTED: 'FORMAS_PAGO_LOAD_REQUESTED',
  FORMAS_PAGO_LOAD_SUCCEEDED: 'FORMAS_PAGO_LOAD_SUCCEEDED',
  FORMAS_PAGO_LOAD_FILED: 'FORMAS_PAGO_LOAD_FILED',
}

export const getFormasPagoAction = dispatch => {
  dispatch({
    type: actions.FORMAS_PAGO_LOAD_REQUESTED,
  })
}
